import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Cart from './components/Cart';
import Home from './pages/Home';
import Shop from './pages/Shop';
import CarWashTrolley from './pages/CarWashTrolley';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import ProductDetails from './pages/ProductDetails';
import TrolleyDetails from './pages/TrolleyDetails';
import Voucher from './pages/Voucher';
import CartSnackbar from './components/CartSnackbar';
import VoucherDetails from './pages/VoucherDetails';
 
import LoyaltyProgram from './pages/LoyaltyProgram';
import LoyaltyCardDetails from "./pages/LoyaltyCardDetails";
import LoyaltyBookletCard from "./pages/LoyaltyBookletCard";

import './App.css';

// ScrollToTop component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);

  const addToCart = (product) => {
    setCartItems(prevItems => {
      const existingItem = prevItems.find(item => item.id === product.id);
      if (existingItem) {
        return prevItems.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      } else {
        return [...prevItems, { ...product, quantity: 1 }];
      }
    });
    setShowSnackbar(true);
    setTimeout(() => setShowSnackbar(false), 3000);
  };

  const updateCartQuantity = (productId, newQuantity) => {
    if (newQuantity <= 0) {
      removeFromCart(productId);
      return;
    }
    setCartItems(prevItems =>
      prevItems.map(item =>
        item.id === productId
          ? { ...item, quantity: newQuantity }
          : item
      )
    );
  };

  const removeFromCart = (productId) => {
    setCartItems(prevItems => prevItems.filter(item => item.id !== productId));
  };

  const cartItemCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header 
          onCartClick={() => setIsCartOpen(true)}
          cartItemCount={cartItemCount}
        />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop onAddToCart={addToCart} />} />
            <Route path="/car-wash-trolley" element={<CarWashTrolley onAddToCart={addToCart} />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
             <Route path="/loyalty-program" element={<LoyaltyProgram />} />
            <Route path="/product/:id" element={<ProductDetails onAddToCart={addToCart} />} />
            <Route path="/trolley/:id" element={<TrolleyDetails />} />
            <Route path="/loyalty-booklet" element={<Voucher onAddToCart={addToCart} />} />
            <Route path="/loyalty-booklet/:id" element={<VoucherDetails />} />
            <Route path="/loyalty-card-details" element={<LoyaltyCardDetails />} />
            <Route path="/loyalty-booklet-card" element={<LoyaltyBookletCard />} />
          </Routes>
        </main>
        <Footer />
        <Cart
          isOpen={isCartOpen}
          onClose={() => setIsCartOpen(false)}
          cartItems={cartItems}
          onUpdateQuantity={updateCartQuantity}
          onRemoveItem={removeFromCart}
        />
        <CartSnackbar
          open={showSnackbar}
          total={cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0)}
          onViewCart={() => { setIsCartOpen(true); setShowSnackbar(false); }}
          onClose={() => setShowSnackbar(false)}
        />
      </div>
    </Router>
  );
}

export default App;